import NotificationBell from './NotificationBell';

/** Business-scoped inbox (uses `Business-Id` from axios + selected business). */
export default function BusinessNotificationBell() {
  return <NotificationBell scope='business' />;
}
